import { render } from "./AuthenticationCardLogo.vue?vue&type=template&id=27f3c58a&scoped=true"
import script from "./AuthenticationCardLogo.vue?vue&type=script&lang=js"
export * from "./AuthenticationCardLogo.vue?vue&type=script&lang=js"

import "./AuthenticationCardLogo.vue?vue&type=style&index=0&id=27f3c58a&lang=sass&scoped=true"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f3c58a"]])

export default __exports__